export default __webpack_public_path__ + "static/media/TeacherIcon.cc985cd4.svg";